import { getLocalTimeZone, today } from '@internationalized/date';

import type { DialogParams } from '@/components/content/confirmationdialog/types';

export const URGENT_DEADLINE_DIALOG: DialogParams = {
  title: 'Urgent request',
  text: 'A 1-day deadline makes this an urgent-type RFI. We will get to it as soon as possible, and the price will be multiplied by 2x.',
  confirmText: 'Submit urgent request',
  confirmColor: 'var(--quo-power-75)',
};

export const earliestDeadline = (): string => today(getLocalTimeZone()).add({ days: 1 }).toString();

export const isUrgentDeadline = (dueDate?: string): boolean => dueDate === earliestDeadline();
